export enum EmployedStatus {
  Employed = "Employed",
  Unemployed = "Unemployed",
  Retired = "Retired",
  Independent = "Independent"
}

export enum PendingTaskType {
  ProjectApplication = "ProjectApplication",
  CanopyAnswer = "CanopyAnswer",
  Survey = "Survey",
  CustomerInsight = "CustomerInsight"
}

export enum EstimatedDuration {
  OneHour = "OneHour",
  Async = "Async",
  OneMinute = "OneMinute"
}

export enum PendingTaskEngagementType {
  ExpertCall = "ExpertCall",
  VideoQA = "VideoQA",
  Survey = "Survey",
  ProfileCompletion = "ProfileCompletion"
}

export enum CompensationUnit {
  PerHour = "PerHour",
  Fixed = "Fixed",
  PerView = "PerView"
}

export enum REQUEST_ENDORSEMENT_FORM_FIELD {
  FULL_NAME = "fullName",
  EMAIL = "email"
}
